import { MANUFACTURING, PACKING } from 'constants/consignmentStates';
import { CREDIT_SOURCES } from 'constants/credit';
import { CONSIGNMENT_TYPES } from 'constants/order';
import { PAYMENT_STATUS } from 'constants/paymentStatus';
import { PURCHASE_ORDER } from 'constants/paymentTypes';
import { ConsignmentDetails } from 'data/Consignment';
import FeatureFlag from 'data/FeatureFlag';
import User, { Role } from 'data/User';
import Vendor from "data/Vendor";

export const checkUserSalesOrderVendorOption = (user: User | null, selectedVendor: Vendor | undefined, tabValue: string) => {

    const isAdminOrSuperAdmin = user?.role === Role.Admin || user?.role === Role.SuperAdmin;
    const isVendorAdmin = user?.role === Role.VendorAdmin;
    
    return selectedVendor?.isSlbVendor
      ? isVendorAdmin || isAdminOrSuperAdmin
      : isAdminOrSuperAdmin;

}

export const isSalesOrderEnabled = (
    flags: FeatureFlag, 
    value: string = ''
  ) => {
  
    return (value === 'Sales Order')
      ? flags.salesOrder && Boolean(flags.salesOrder.enabled)
      : true;
  };

export const checkIsSalesOrderApplicable = (consignment: ConsignmentDetails): boolean | undefined => {
  // series of checks to determine if sales order is applicable for the consignment
  if(!consignment) return false;

  const productCodes = consignment.consignmentEntries?.map(entry => entry.code) || [];

  return !consignment.salesOrderNumber
        && [MANUFACTURING, PACKING].includes(consignment.state)
        && (consignment.paymentStatus === PAYMENT_STATUS.PAID || consignment.paymentType === PURCHASE_ORDER) 
        && consignment.consignmentType === CONSIGNMENT_TYPES.PURCHASE
        && consignment.vendor?.isSlbVendor
        && consignment.vendor?.isSalesApiEnabled
        && consignment.consignmentEntries?.every(x => x?.brandVendor?.isSalesOrderApiEnabled)
        && consignment.consignmentAutomationFlags?.every(x => productCodes.includes(x.productVariantCode) && x.materialApiValidation && x.stocksApiValidation)
        && (consignment.paymentType === PURCHASE_ORDER ? consignment.creditSource === CREDIT_SOURCES.MDM : true)
}